module.exports = __webpack_public_path__ + "img/icon-down.ae9a20a9.svg";